import React, { useState } from 'react';
import { Modal, Tree, message } from 'antd';
import { Folder } from '../../types/testItem';
import { useTranslation } from 'react-i18next';

interface Props {
    open: boolean;
    onClose: () => void;
    folders: Folder[];
    onSelect: (folder: Folder | number) => void;
}

interface TreeNode {
    title: string;
    key: number;
    children: TreeNode[];
}

export const SelectFolderModal: React.FC<Props> = ({
    open,
    onClose,
    folders,
    onSelect,
}) => {
    const { t } = useTranslation();
    const [selectedFolder, setSelectedFolder] = useState<number | null>(null);

    const handleSelect = () => {
        if (!selectedFolder) {
            message.warning(t('modals.selectFolder.warning'));
            return;
        }
        const folder = folders.find(f => f.id === selectedFolder);
        if (folder) {
            onSelect(folder);
            onClose();
        }
    };

    const buildTreeData = (items: Folder[], parentId: number | null = null): TreeNode[] => {
        return items
            .filter(item => item.parent_id === parentId)
            .map(item => ({
                title: item.name || 'Без названия',
                key: item.id,
                children: buildTreeData(items, item.id)
            }));
    };

    return (
        <Modal
            title="Выберите папку"
            open={open}
            onCancel={onClose}
            onOk={handleSelect}
            okText="Добавить"
            cancelText="Отмена"
        >
            <Tree
                treeData={buildTreeData(folders)}
                onSelect={(selectedKeys) => {
                    if (selectedKeys.length > 0) {
                        setSelectedFolder(Number(selectedKeys[0]));
                    }
                }}
            />
        </Modal>
    );
}; 